﻿/**********************************************************************************************
* OntarioTECK VBA Developers
* Developed by Gustavo Miller
* Date created : 2026-04-20 05:18:45.863
*
* Location: D:\Acorns and Oaks (AAO)\AAO\wwwroot\
* Filename: js\home.js
*
**********************************************************************************************/
import { implementPopover, ConfigurePopover } from "./utilities/popUtils.js"
import { initTinyMce } from './api/tinyinitializer.js';

declare const tinymce: any;

function validateEmailEntry(): void {
    const form = document.querySelector<HTMLFormElement>(".email-form");
    if (!form) return;

    const requiredFields = form
        .querySelectorAll<HTMLInputElement | HTMLSelectElement>("[required]");

    const sendBtn = document.getElementById("sendBtn") as HTMLButtonElement | null;
    if (!sendBtn) return;

    function validateForm(): void {
        const allFilled = Array.from(requiredFields).every(field =>
            field.value.trim().length > 0 );

        if (allFilled == true) {
            sendBtn.removeAttribute("disabled");
        }
    }

    requiredFields.forEach(field => {
        field.addEventListener("input", validateForm);
    });

    validateForm();
}

document.addEventListener("DOMContentLoaded", async (event) => {
    console.info(`Acorns and Oaks Fire up!`);

    await implementPopover("Index");
    console.log(`Implement Popover`);

    ConfigurePopover(5000);
    console.log(`Configure Popover`);

    console.log(`Initialize TinyMCE`);
    await initTinyMce("#message");

    console.log(`Load TinyMCE`);
    const editor = tinymce.get("message");

    validateEmailEntry();

});